import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "focused"];
var StyledTreeNodeBase = styled.div.withConfig({
  displayName: "TreeNodeBase__StyledTreeNodeBase",
  componentId: "sc-kgunqe-0"
})({
  "&:focus": {
    outline: "none"
  }
});

var TreeNodeBase = function TreeNodeBase(_ref) {
  var children = _ref.children,
      focused = _ref.focused,
      rest = _objectWithoutProperties(_ref, _excluded);

  var ref = React.useRef(null);
  React.useEffect(function () {
    if (focused) {
      var _ref$current;

      ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
  }, [focused]);
  return /*#__PURE__*/jsx(StyledTreeNodeBase, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    children: children
  }));
};

TreeNodeBase.propTypes = {
  "children": _PropTypes.node,
  "focused": _PropTypes.bool
};
TreeNodeBase.displayName = "TreeNodeBase";

export { TreeNodeBase };
